import deepStrictEqual from 'deep-strict-equal';

function arrayContains( arr, element, equalFn ) {
  if ( arr && arr.length && typeof arr !== 'string' ) {
    for ( let currentElement of arr ) {
      if ( equalFn( element, currentElement ) ) {
        return true;
      }
    }
  }
  return false;
}

const equalFn = Symbol();

export class Set {
  constructor( equalFunction = null ) {
    this.set = [];
    this[equalFn] = ( obj1, obj2 ) => equalFunction && equalFunction.apply ? equalFunction( obj1, obj2 ) : deepStrictEqual( obj1, obj2 );
  }

  add( element ) {
    if ( !element || this.contains( element ) ) {
      return false;
    }
    this.set.push( element );
    return true;
  }

  addAll( elements ) {
    let counter = 0;
    if ( elements && elements.length && typeof elements !== 'string' ) {
      for ( let tmpElement of elements ) {
        this.add( tmpElement ) && counter++;
      }
    }
    return counter > 0;
  }

  clear( ) {
    this.set.splice( 0, this.size() );
  }

  contains( element ) {
    for ( let tmpElement of this.set ) {
      if ( this[equalFn]( tmpElement, element ) ) {
        return true;
      }
    }

    return false;
  }

  containsAll( elements ) {
    if ( elements && Array.isArray( elements ) ) {
      for ( let tmpElement of elements ) {
        if ( !this.contains( tmpElement ) ) {
          return false;
        }
      }
      return true;
    }

    return false;
  }

  equals( elements ) {
    if ( elements === this.set ) {
      return true;
    }
    if ( elements && elements.length === this.size() && typeof elements !== 'string' ) {
      for ( let tmpElement of elements ) {
        if ( !this.contains( tmpElement ) ) {
          return false;
        }
      }
      
      return true;
    }

    return false;
  }

  isEmpty( ) {
    return this.size() === 0;
  }

  remove( element ) {
    for ( let i = 0; i < this.size( ); i++ ) {
      if ( this[equalFn]( this.set[i], element ) ) {
        this.set = [...this.set.slice( 0, i ), ...this.set.slice( i + 1 )];
        return true;
      }
    }
    return false;
  }

  removeAll( elements ) {
    let removed = false;
    if ( elements && elements.length && typeof elements !== 'string' ) {
      for ( let tmpElement of elements ) {
        removed ? this.remove( tmpElement ) : removed = this.remove( tmpElement );
      }
    }

    return removed;
  }

  removeByIndex( index ) {
    if ( typeof index === 'number' && index > -1 && index < this.set.length ) {
      this.set.splice( index, 1 );
      return true;
    }
    return false;
  }

  replaceOrAdd( value, isItemToReplace ) {
    if ( isItemToReplace && isItemToReplace.apply ) {
      let replaced = false;
      for ( let i = 0; i < this.size(); i++ ) {
        if ( isItemToReplace( value, this.set[i] ) ) {
          this.set = [...this.set.slice( 0, i ), value, ...this.set.slice( i + 1 )];
          replaced = true;
          break;
        }
      }

      !replaced && this.add( value );
    } else {
      return this.replaceOrAdd( value, this[equalFn] );
    }
    return this.set;
  }

  retainAll( elements ) {
    let retainAll = false;
    if ( elements && elements.length >= 0 && typeof elements !== 'string' ) {
      for ( let i = this.size(); --i >= 0; ) {
        if ( arrayContains( elements, this.set[i], this[equalFn] ) ) {
          continue;
        }
        retainAll ? this.removeByIndex( i ) : retainAll = this.removeByIndex( i );
      }
    }
    return retainAll;
  }

  size( ) {
    return this.set.length;
  }

  toArray( ) {
    return [...this.set];
  }
}